// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2teO9","title":"Header_title__3lWht","side":"Header_side__3bV4Y"};